import {
  linkedinPosts,
  workflowInstance,
  workflowInstances,
  workflowMatchedContacts,
  workflows,
} from '@/constants/endpoints';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

export function fetchWorkflows(params = {}) {
  // Extract parameters for pagination and filtering
  const { page, per_page, status, name } = params;

  // Construct query params
  const queryParams = {};

  if (page) queryParams.page = page;
  if (per_page) queryParams.per_page = per_page;
  if (status !== undefined) queryParams.status = status;
  if (name) queryParams.name = name;

  return apiClient.get(
    workflows,
    Object.keys(queryParams).length ? queryParams : null,
    true
  );
}

export function fetchWorkflowInstances(params) {
  // Extract parameters for pagination and filtering
  const { status, workflowId, page, per_page } = params;

  // Construct query params
  const queryParams = {};

  if (status !== 'all') queryParams.status = status;
  if (workflowId) queryParams.workflow_id = workflowId;
  if (page) queryParams.page = page;
  if (per_page) queryParams.per_page = per_page;

  return apiClient.get(
    workflowInstances,
    Object.keys(queryParams).length ? queryParams : null,
    true
  );
}

export function fetchWorkflowInstance(workflowInstanceId) {
  console.log('workflowInstanceId', workflowInstanceId);
  return apiClient.get(workflowInstance(workflowInstanceId), null, true);
}

export function checkWorkflowMatchedContacts(triggerDetails) {
  return apiClient.create(workflowMatchedContacts, triggerDetails, true);
}

export function createWorkflow(workflow) {
  return apiClient.create(workflows, workflow, true);
}

export function updateWorkflowStatus(workflowId, data) {
  const url = `${workflows}/${workflowId}`;
  return apiClient.overwrite(url, data, true);
}

export function updateWorkflowInstance(workflowInstanceId, workflow) {
  return apiClient.overwrite(
    workflowInstance(workflowInstanceId),
    workflow,
    true
  );
}

export function deleteWorkflowInstance(workflowInstanceId) {
  return apiClient.delete(workflowInstance(workflowInstanceId), null, true);
}

export function fetchLinkedInPosts(params = {}) {
  const { q, force } = params;

  // Construct query params
  const queryParams = {};

  if (q) queryParams.q = q;
  if (force) queryParams.force = true;

  return apiClient.get(
    linkedinPosts,
    Object.keys(queryParams).length ? queryParams : null,
    true
  );
}
